import classNames from 'classnames';
import React from 'react';
import Heading from '../Heading/Heading';
import './Shelf.scss';

export interface ShelfProps extends React.HTMLProps<HTMLDivElement> {
  variant: 'transparent' | 'white' | 'lilac' | 'purple';
  title: string;
  children: React.ReactNode | React.ReactNode[];
  image?: string;
}

const Shelf = ({ title, children, image, variant = 'transparent', ...rest }: ShelfProps) => {
  const classes = classNames('mss-shelf', {
    'mss-shelf--lilac': variant === 'lilac',
    'mss-shelf--purple': variant === 'purple',
    'mss-shelf--white': variant === 'white'
  });

  return (
    <div className={classes} {...rest}>
      <div className="zb-container">
        <div className="mss-shelf__container">
          <div className="mss-shelf__content">
            <Heading level={1} as="h2" alternative>
              {title}
            </Heading>
            {children}
          </div>
          {image && (
            <div className="mss-shelf__image">
              <img src={image} alt="" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Shelf;
